/**
 * 診断コンテンツ 計測トラッキング (v2 / 複数診断対応)
 * ------------------------------------------------------------------
 * 対象: Shopifyテーマの診断セクション (既定: content-diagnosis-tool)
 *       現在は /collections/kinujo の「あなたにぴったりのKINUJO診断」
 *
 * 方式: 既存の kinujo-diagnosis.js は一切変更せず、prototype をラップして
 *       dataLayer に push する。
 *
 * 設置: assets/ に配置し、theme.liquid の </body> 直前で読み込む。
 *       {{ 'kinujo-diagnosis-tracking.js' | asset_url | script_tag }}
 *
 * ★診断が増えたときの対応
 *   1) 同じセクション(content-diagnosis-tool)を別ページ/別内容で使う場合
 *      → このファイルの修正は【不要】。diagnosis_id で自動的に区別されます。
 *        識別名を明示したい場合のみ、セクションのルート要素に
 *        data-diagnosis-name="dryer" のように付与してください。
 *   2) 別のセクションタイプで新しい診断を作る場合
 *      → 下の SECTION_TYPES に文字列を1つ追加するだけです。
 *
 * 送信イベント (すべて diagnosis_id を含む):
 *   kinujo_diagnosis_start         診断を開始
 *   kinujo_diagnosis_answer        設問に回答
 *   kinujo_diagnosis_back          「戻る」をクリック
 *   kinujo_diagnosis_complete      診断結果を表示
 *   kinujo_diagnosis_result_click  結果のメインボタン(View more)をクリック
 *   kinujo_diagnosis_add_to_cart   結果の BUY をクリック
 *   kinujo_diagnosis_related_click 関連商品をクリック
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* === 設定: 診断セクションが増えたらここに追加 ===================== */
  var SECTION_TYPES = ['content-diagnosis-tool'];
  /* ================================================================= */

  window.dataLayer = window.dataLayer || [];

  function push(obj) {
    try {
      window.dataLayer.push(obj);
      if (window.__KINUJO_DIAG_DEBUG) console.log('[diagnosis]', obj);
    } catch (e) { /* 計測失敗でサイトを壊さない */ }
  }

  /** HTML入りのラベルからプレーンテキストを取り出す */
  function toText(html) {
    if (!html) return '';
    /* <template> の中身は inert（<img onerror> 等のハンドラが実行されない） */
    var t = document.createElement('template');
    t.innerHTML = html;
    var txt = t.content ? t.content.textContent : t.textContent;
    return (txt || '').replace(/\s+/g, ' ').trim();
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /**
   * 診断の識別子。複数の診断を区別するために全イベントへ付与する。
   * 優先順: ルート要素の data-diagnosis-name → セクションコンテナのID → 'unknown'
   */
  function diagnosisId(instance) {
    try {
      var named = instance.root && instance.root.getAttribute('data-diagnosis-name');
      if (named) return named;
      if (instance.container && instance.container.id) return instance.container.id;
    } catch (e) { /* noop */ }
    return 'unknown';
  }

  /** クリックされた要素から、所属する診断の状態を取り出す（セレクタ非依存） */
  function stateFrom(el) {
    var n = el;
    while (n && n !== document) {
      if (n.__kinujoState) return n.__kinujoState;
      n = n.parentNode;
    }
    return {};
  }

  /**
   * 開始ボタンのクラス（js-modal-open-<モーダルclass>）から診断IDを解決する。
   * 開始ボタンはモーダルの外側にあるため、対応するモーダル要素を探して
   * 他イベントと同じIDに揃える。これをしないと start だけIDがズレる。
   */
  function resolveIdFromModalClass(modalClass) {
    try {
      var el = document.querySelector('.' + modalClass);
      if (!el) return modalClass;
      var named = el.getAttribute('data-diagnosis-name');
      if (named) return named;
      var sec = el.closest ? el.closest('[data-section-type]') : null;
      if (sec && sec.id) return sec.id;
      var anyId = el.closest ? el.closest('[id]') : null;
      if (anyId && anyId.id) return anyId.id;
    } catch (e) { /* noop */ }
    return modalClass;
  }

  /* ------------------------------------------------------------------
   * 1) prototype のラップ
   *    描画のたびに、状態をルート要素へ・回答データを各ボタンへ紐付ける
   * ------------------------------------------------------------------ */
  function patchOne(sectionType) {
    if (!window.theme || !theme.sections || !theme.sections.constructors) return false;

    var Ctor = theme.sections.constructors[sectionType];
    if (!Ctor || !Ctor.prototype) return false;
    if (Ctor.prototype.__kinujoTracked) return true; // 二重適用防止

    var P = Ctor.prototype;
    P.__kinujoTracked = true;

    var origRenderQuestion = P.renderQuestion;
    var origRenderResult = P.renderResult;

    /* --- 設問の描画 ------------------------------------------------- */
    if (typeof origRenderQuestion === 'function') {
      P.renderQuestion = function (node) {
        var ret = origRenderQuestion.apply(this, arguments);
        try {
          var did = diagnosisId(this);
          var qid = this.current;
          var stepNo = this.historyStack.length + 1;
          var qtext = toText(node && node.text);

          this.root.__kinujoState = {
            diagnosis_id: did,
            phase: 'question',
            question_id: qid,
            question_no: stepNo,
            question_text: qtext,
            total_steps: this.totalSteps
          };

          /* クラス接頭辞に依存しないセレクタ（将来の別診断でも拾える） */
          var btns = this.body.querySelectorAll('button[class*="__option"]');
          (node && node.answers ? node.answers : []).forEach(function (answer, i) {
            if (!btns[i]) return;
            btns[i].__kinujoAnswer = {
              diagnosis_id: did,
              question_id: qid,
              question_no: stepNo,
              question_text: qtext,
              answer_letter: answer.letter || '',
              answer_label: toText(answer.label),
              answer_index: i + 1,
              next_id: answer.target || ''
            };
          });
        } catch (e) { /* noop */ }
        return ret;
      };
    }

    /* --- 結果の描画 ------------------------------------------------- */
    if (typeof origRenderResult === 'function') {
      P.renderResult = function (key) {
        var ret = origRenderResult.apply(this, arguments);
        try {
          var did = diagnosisId(this);
          var data = (this.resultsData && this.resultsData[key]) || {};
          var p = data.product || {};

          var state = {
            diagnosis_id: did,
            phase: 'result',
            result_key: key,
            result_product: p.title || '',
            result_url: p.url || '',
            result_variant_id: p.variantId ? String(p.variantId) : ''
          };
          this.root.__kinujoState = state;

          /* 結果画面のアクションにマーカーを付ける（クリック時はこれだけを見る） */
          var body = this.body;
          var vm = body.querySelector('[class*="__result-button"]');
          if (vm) vm.__kinujoAction = { kind: 'result_click' };

          var buy = body.querySelector('form[action*="/cart/add"] button[type="submit"]');
          if (!buy) buy = body.querySelector('[class*="__buy-button"]');
          if (buy) buy.__kinujoAction = { kind: 'add_to_cart' };

          var rel = body.querySelectorAll('[class*="__related-item"]');
          for (var i = 0; i < rel.length; i++) rel[i].__kinujoAction = { kind: 'related_click' };

          push({
            event: 'kinujo_diagnosis_complete',
            diagnosis_id: did,
            diagnosis_result_key: key,
            diagnosis_result_product: p.title || '',
            diagnosis_result_subtitle: p.subtitle || '',
            diagnosis_result_url: p.url || '',
            diagnosis_result_variant_id: p.variantId ? String(p.variantId) : '',
            diagnosis_steps: this.historyStack.length
          });
        } catch (e) { /* noop */ }
        return ret;
      };
    }

    return true;
  }

  function patchAll() {
    var done = true;
    for (var i = 0; i < SECTION_TYPES.length; i++) {
      if (!patchOne(SECTION_TYPES[i])) done = false;
    }
    return done;
  }

  /* コンストラクタ登録の完了を待つ（最大10秒。無ければ静かに終了） */
  (function waitAndPatch(tries) {
    if (patchAll()) return;
    if (tries <= 0) return;
    setTimeout(function () { waitAndPatch(tries - 1); }, 200);
  })(50);

  /* ------------------------------------------------------------------
   * 2) クリック計測（capture = 元の処理より先に状態を読む）
   *    回答・結果アクションは要素に付けたマーカーだけを見るので
   *    クラス名が変わっても壊れない
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* --- 診断スタート ---------------------------------------------- */
    /* js-modal-open-*diagnosis* を持つ要素を自動で拾う               */
    var opener = closest(t, '[class*="js-modal-open-"]');
    if (opener) {
      var cls = (opener.className || '').toString();
      var m = cls.match(/js-modal-open-([A-Za-z0-9_-]*diagnosis[A-Za-z0-9_-]*)/);
      if (m) {
        push({
          event: 'kinujo_diagnosis_start',
          diagnosis_id: resolveIdFromModalClass(m[1]),
          diagnosis_entry: cls.indexOf('--sticky') !== -1 ? 'sticky' : 'inline',
          diagnosis_entry_text: (opener.textContent || '').replace(/\s+/g, ' ').trim()
        });
      }
      return;
    }

    /* --- 設問に回答（マーカー参照） --------------------------------- */
    var optBtn = closest(t, 'button');
    if (optBtn && optBtn.__kinujoAnswer) {
      var a = optBtn.__kinujoAnswer;
      push({
        event: 'kinujo_diagnosis_answer',
        diagnosis_id: a.diagnosis_id,
        diagnosis_question_id: a.question_id,
        diagnosis_question_no: a.question_no,
        diagnosis_question_text: a.question_text,
        diagnosis_answer_letter: a.answer_letter,
        diagnosis_answer_label: a.answer_label,
        diagnosis_answer_index: a.answer_index,
        diagnosis_next_id: a.next_id,
        diagnosis_is_final: a.next_id.indexOf('result:') === 0
      });
      return;
    }

    /* --- 結果画面のアクション（マーカー参照） ------------------------ */
    var actionEl = t;
    while (actionEl && actionEl !== document && !actionEl.__kinujoAction) {
      actionEl = actionEl.parentNode;
    }
    if (actionEl && actionEl.__kinujoAction) {
      var s = stateFrom(actionEl);
      var kind = actionEl.__kinujoAction.kind;

      if (kind === 'result_click') {
        push({
          event: 'kinujo_diagnosis_result_click',
          diagnosis_id: s.diagnosis_id || '',
          diagnosis_result_key: s.result_key || '',
          diagnosis_result_product: s.result_product || '',
          diagnosis_result_url: actionEl.getAttribute('href') || s.result_url || ''
        });
      } else if (kind === 'add_to_cart') {
        push({
          event: 'kinujo_diagnosis_add_to_cart',
          diagnosis_id: s.diagnosis_id || '',
          diagnosis_result_key: s.result_key || '',
          diagnosis_result_product: s.result_product || '',
          diagnosis_result_variant_id: s.result_variant_id || ''
        });
      } else if (kind === 'related_click') {
        var titleEl = actionEl.querySelector('[class*="__related-title"]');
        push({
          event: 'kinujo_diagnosis_related_click',
          diagnosis_id: s.diagnosis_id || '',
          diagnosis_result_key: s.result_key || '',
          diagnosis_related_product: titleEl ? (titleEl.textContent || '').trim() : '',
          diagnosis_related_url: actionEl.getAttribute('href') || ''
        });
      }
      return;
    }

    /* --- 戻る ------------------------------------------------------- */
    var backBtn = closest(t, '[data-diagnosis-back]');
    if (backBtn) {
      var bs = stateFrom(backBtn);
      push({
        event: 'kinujo_diagnosis_back',
        diagnosis_id: bs.diagnosis_id || '',
        diagnosis_question_id: bs.question_id || bs.result_key || '',
        diagnosis_question_no: bs.question_no || null
      });
      return;
    }
  }, true); // capture:true
})();
